<template>
  <v-row>
    <v-col cols="12" class="display-1 font-weight-medium">
      Work
    </v-col>
    
    <v-col cols="12" class="text-left">
      <v-card class="pa-5" style="border-radius: 20px;">
        <v-card-title style="word-wrap: break-word; word-break: normal;" class="mb-0 pb-5">
         Freelancer
        </v-card-title>

        <v-card-subtitle class="font-weight-medium colored mb-1">
          <span class="title font-italic">Web Developer, Photographer, Communicant</span><br/>
          2019 - now
        </v-card-subtitle>

        <v-card-text class="font-weight-medium body-1" style="line-height: 1.6;">
          <p>
            Companies I've been working with:<br/>
            <ul>
              <li class="grey--text text--darken-3">Grants4sme (4 projects)</li>
              <ul class="body-1">
                <li>Creation of a Customer Management System (prototype and alpha)</li>
                <li>Proofreading of documents</li>
              </ul>
              <li class="grey--text text--darken-3">NORR Agency (1 project)</li>
              <ul class="body-1">
                <li>Photography for a full-page article</li>
              </ul>
              <li class="grey--text text--darken-3">Polydelic (1 project)</li>
              <ul class="body-1">
                <li>Technology and capability research for an application for the EV market</li>
              </ul>
            </ul>
          </p>

          <p>
            Skills:<br/>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-language-html5</v-icon>
              </v-avatar>
              HTML
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-language-css3</v-icon>
              </v-avatar>
              CSS
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-language-javascript</v-icon>
              </v-avatar>
              JavaScript
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-vuejs</v-icon>
              </v-avatar>
              Vue.js
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-firebase</v-icon>
              </v-avatar>
              Firebase
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-camera</v-icon>
              </v-avatar>
              Photography
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-forum</v-icon>
              </v-avatar>
              Communication
            </v-chip>
          </p>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" class="text-left">
      <v-card class="pa-5" style="border-radius: 20px;">
        <v-card-title style="word-wrap: break-word; word-break: normal;" class="mb-0 pb-5">
         Co-Founder, Teacher and Product Manager
        </v-card-title>

        <v-card-subtitle class="font-weight-medium colored mb-1">
          <span class="title font-italic">CodeAndGo</span><br/>
          <span class="subtitle-1 font-italic">Oslo, Norway</span><br/>
          2018 - 2020, 1 year 6 months
        </v-card-subtitle>

        <v-card-text class="font-weight-medium body-1" style="line-height: 1.6;">
          <p>
            Responsibilities:<br/>
            <ul>
              <li>Development of curriculums and coding courses</li>
              <li>Development of a website with administrative panel</li>
              <li>Teaching coding courses</li>
            </ul>
          </p>

          <p>
            Skills:<br/>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-language-html5</v-icon>
              </v-avatar>
              HTML
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-language-css3</v-icon>
              </v-avatar>
              CSS
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-language-javascript</v-icon>
              </v-avatar>
              JavaScript
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-draw</v-icon>
              </v-avatar>
              p5.js
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-vuejs</v-icon>
              </v-avatar>
              Vue.js
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-firebase</v-icon>
              </v-avatar>
              Firebase
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-account-group</v-icon>
              </v-avatar>
              Teamwork
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-teach</v-icon>
              </v-avatar>
              Pedagogy
            </v-chip>
          </p>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" class="text-left">
      <v-card class="pa-5" style="border-radius: 20px;">
        <v-card-title style="word-wrap: break-word; word-break: normal;" class="mb-0 pb-5">
          Web Developer, Teacher and CTO
        </v-card-title>

        <v-card-subtitle class="font-weight-medium colored mb-1">
          <span class="title font-italic">Bitcamp</span><br/>
          <span class="subtitle-1 font-italic">Oslo, Norway</span><br/>
          2018, 7 months
        </v-card-subtitle>

        <v-card-text class="font-weight-medium body-1" style="line-height: 1.6;">
          <p>
            Responsibilities:<br/>
            <ul>
              <li>Development of a learning platform</li>
              <li>Development of coding courses for teenagers</li>
              <li>Teaching coding courses</li>
            </ul>
          </p>

          <p>
            Skills:<br/>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-language-html5</v-icon>
              </v-avatar>
              HTML
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-language-css3</v-icon>
              </v-avatar>
              CSS
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-language-javascript</v-icon>
              </v-avatar>
              JavaScript
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-draw</v-icon>
              </v-avatar>
              p5.js
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-vuejs</v-icon>
              </v-avatar>
              Vue.js
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-leaf</v-icon>
              </v-avatar>
              MongoDB
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-cable-data</v-icon>
              </v-avatar>
              Express
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-nodejs</v-icon>
              </v-avatar>
              Node.js
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-aws</v-icon>
              </v-avatar>
              AWS
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-account-group</v-icon>
              </v-avatar>
              Teamwork
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-teach</v-icon>
              </v-avatar>
              Pedagogy
            </v-chip>
          </p>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" class="text-left">
      <v-card class="pa-5" style="border-radius: 20px;">
        <v-card-title style="word-wrap: break-word; word-break: normal;" class="mb-0 pb-5">
          Consultant in communication
        </v-card-title>

        <v-card-subtitle class="font-weight-medium colored mb-1">
          <span class="title font-italic">Center for Environmental Radioactivity (CERAD)</span><br/>
          <span class="subtitle-1 font-italic">Ås, Norway</span><br/>
          2017 - 2020, 3 months per year
        </v-card-subtitle>

        <v-card-text class="font-weight-medium body-1" style="line-height: 1.6;">
          <p>
            Responsibilities:<br/>
            <ul>
              <li>Creation of the yearly report</li>
              <li>Formatting of the text and the report</li>
              <li>Improvement in the premade template in the given style limits</li>
            </ul>
          </p>

          <p>
            Skills:<br/>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-adobe</v-icon>
              </v-avatar>
              InDesign
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-file-word</v-icon>
              </v-avatar>
              Microsoft Word
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-adobe</v-icon>
              </v-avatar>
              Illustrator
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-forum</v-icon>
              </v-avatar>
              Communication
            </v-chip>
            <v-chip outlined color="rgba(79, 179, 108)" class="mr-3 mt-3">
              <v-avatar left>
                <v-icon>mdi-account-group</v-icon>
              </v-avatar>
              Teamwork
            </v-chip>
          </p>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {

}
</script>

<style>
.colored {
  color: rgba(79, 179, 108) !important;
}
</style>